import React, { useState, useEffect } from "react";
import plusIcon from "../assets/img/icon-plus.png";
import Popup from "./Popup";
import { formatDateToDDMMYY } from "../utils/format-time";
import { formatNumberWithCommas } from "../utils/format-number";

const RetailSalesOrderTable = ({
  data,
  setActiveTab,
  promotionByTotal,
  setPromotionByTotal,
  currencyType,
  THBToMMK,
  MMKToTHB,
  setSubTotal,
  setSaleProducts,
  setSubTotalTHB,
  setSubTotalMMK,
  title = "Retail Sales Order Information",
}) => {
  const formatRetailAmount = (value, currency) => {
    if (value === null || value === undefined || value === "") {
      return "";
    }

    const numericValue = Number(String(value).replace(/,/g, ""));
    if (!Number.isFinite(numericValue)) {
      return "";
    }

    const maximumFractionDigits = currency === "BAHT" ? 6 : 2;
    const minimumFractionDigits =
      numericValue % 1 === 0 ? 0 : Math.min(2, maximumFractionDigits);

    return numericValue.toLocaleString("en-US", {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  };

  const [popup, setPopup] = useState({
    id: "",
    show: false,
  });

  const [errorBuyMessage, setErrorBuyMessage] = useState("");

  const onCloseClick = (e) => {
    e.preventDefault();
    setPopup({
      id: "",
      show: false,
    });
  };

  const convertCurrency = (product, currencyType, THBToMMK, MMKToTHB) => {
    let convertedPrice;

    if (currencyType === product.currency) {
      convertedPrice = product.retail_price;
    } else {
      if (product.currency === "MMK") {
        convertedPrice = product.retail_price * MMKToTHB;
      } else {
        convertedPrice = nearValue(product.retail_price / THBToMMK);
      }
    }
    return convertedPrice;
  };

  useEffect(() => {
    document
      .getElementById("external-popup")
      .classList.toggle("show", popup.show);
    const openedEl = document.querySelector(".popup");

    const handleDocumentClick = (e) => {
      if (e.target != openedEl && !openedEl.contains(e.target)) {
        openedEl.parentNode.classList.remove("show");
        onCloseClick(e);
      }
    };
    if (openedEl) {
      setTimeout(() => {
        document.addEventListener("click", handleDocumentClick);
      }, 100);
    }
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [popup.show]);

  const onDetailClick = (e) => {
    e.preventDefault();
    const id = e.target.parentNode.parentNode.id;
    // console.log(id)
    setPopup({
      show: true,
      eID: "promotion-popup",
      id: id,
    });
  };

  const getSubTotal = (currencyType, seperatedType) => {
    let total = 0;

    if (currencyType === "BAHT") {
      data.forEach((product) => {
        total += parseFloat(product.convertedTHBTotal || 0);
      });
    } else if (currencyType === "SEPERATED" && seperatedType === "MMK") {
      data.forEach((product) => {
        if (product.currency === "MMK") {
          const q = Number(product.quantity) || 0;
          const p = Number(product.mmkPrice) || 0;
          total += q * p;
        }
      });
    } else if (currencyType === "SEPERATED" && seperatedType === "BAHT") {
      data.forEach((product) => {
        if (product.currency === "BAHT") {
          const q = Number(product.quantity) || 0;
          const p = Number(product.thbPrice) || 0;
          total += q * p;
        }
      });
    } else {
      data.forEach((product) => {
        total += parseFloat(product.convertedMMKTotal || 0);
      });
    }

    return parseFloat(total.toFixed(2));
  };

  useEffect(() => {
    if (currencyType === "SEPERATED") {
      setSubTotalMMK(getSubTotal(currencyType, "MMK"));
      setSubTotalTHB(getSubTotal(currencyType, "BAHT"));
    } else {
      setSubTotal(getSubTotal(currencyType));
    }
  }, [data, currencyType]);

  const appliedCrossProductRows = (() => {
    const appliedCrossPromotions = data.filter(
      (item) =>
        item.applyPromo &&
        item.promotion_type === "By Cross Product" &&
        item.promotion
    );

    const seenPromotionIds = new Set();

    return appliedCrossPromotions.flatMap((item) => {
      const promotionId =
        item.promotion?.promotion_by_cp_id ??
        item.promotion?.promotion_id ??
        item.product_id;

      if (seenPromotionIds.has(promotionId)) {
        return [];
      }
      seenPromotionIds.add(promotionId);

      const eligibleTimes = Number(item.promotion?.eligibleTimes) || 0;
      const promoProducts = item.promotion?.promoProducts ?? [];

      return promoProducts.map((promoProduct, index) => ({
        isPromoReward: true,
        rowKey: `cross-product-${promotionId}-${index}`,
        barcode: promoProduct.product?.barcode ?? "-",
        product_name: promoProduct.product?.product_name ?? "-",
        quantity: eligibleTimes * (Number(promoProduct.quantity) || 0),
        mmkPrice: 0,
        thbPrice: 0,
        convertedMMKTotal: 0,
        convertedTHBTotal: 0,
        promotionLabel: "Cross Product Reward",
      }));
    });
  })();

  const tableRows = [...data, ...appliedCrossProductRows];

  const PromotionPopup = ({ id }) => {
    let product,
      eligiblePromo,
      applyPromo,
      minimum_total_amount,
      promotion_amount,
      start_date,
      end_date;
    console.log("promotionByTotal retrieve", promotionByTotal);
    //console.log("ID",id)

    if (id === "By Total") {
      const promo = promotionByTotal.promotion;

      eligiblePromo = promo.promotion_type;
      applyPromo = promotionByTotal.applyPromo;
      minimum_total_amount = promo.minimum_total_amount;
      promotion_amount = promo.promotion_amount;
      start_date = promo.start_date;
      end_date = promo.end_date;
    } else {
      product = data.find((item) => item.product_id === id);
      //console.log("Product retrieve:",product);
      eligiblePromo = product.promotion_type;
      // console.log("Promo Type",eligiblePromo)
      applyPromo = product.applyPromo;
    }

    const crossableProducts = product?.promotion?.crossableProducts ?? [];
    const promoProducts = product?.promotion?.promoProducts ?? [];
    const promoStartDate = product?.promotion?.start_date ?? product?.start_date;
    const promoEndDate = product?.promotion?.end_date ?? product?.end_date;

    return (
      <div className="popup">
        <div className="flex flex-row-reverse">
          <button onClick={onCloseClick}>
            <img
              src={plusIcon}
              alt="close icon"
              className="rotate-45 w-5 h-5"
            />
          </button>
        </div>
        {eligiblePromo === "By Total" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Amount</td>
                </tr>
                <tr>
                  <td>Minimum Total Amount</td>
                  <td className="px-8">:</td>
                  <td>{minimum_total_amount}</td>
                </tr>
                <tr>
                  <td>Promotion Amount</td>
                  <td className="px-8">:</td>
                  <td>{promotion_amount}</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By BOGO" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Buy One Get One</td>
                </tr>
                <tr>
                  <td>Product Name</td>
                  <td className="px-8">:</td>
                  <td>{product.product_name}</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By Percent" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Percent</td>
                </tr>
                <tr>
                  <td>Product Name</td>
                  <td className="px-8">:</td>
                  <td>{product.product_name}</td>
                </tr>
                <tr>
                  <td>Promotion Percent</td>
                  <td className="px-8">:</td>
                  <td>{product.percent_amount}%</td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.start_date))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(product.end_date))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {eligiblePromo === "By Cross Product" && (
          <div className="flex justify-center py-2">
            <table className="promotion-detail-table">
              <tbody>
                <tr>
                  <td>Promotion Type</td>
                  <td className="px-8">:</td>
                  <td>Cross Product</td>
                </tr>
                <tr>
                  <td>Buy Products</td>
                  <td className="px-8">:</td>
                  <td>
                    {crossableProducts.map((item, index) => (
                      <div key={`buy-${index}`}>
                        {`${item.product?.product_name ?? "-"} x ${item.quantity}`}
                      </div>
                    ))}
                  </td>
                </tr>
                <tr>
                  <td>Get Products</td>
                  <td className="px-8">:</td>
                  <td>
                    {promoProducts.map((item, index) => (
                      <div key={`get-${index}`}>
                        {`${item.product?.product_name ?? "-"} x ${item.quantity}`}
                      </div>
                    ))}
                  </td>
                </tr>
                <tr>
                  <td>Start Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(promoStartDate))}</td>
                </tr>
                <tr>
                  <td>End Date</td>
                  <td className="px-8">:</td>
                  <td>{formatDateToDDMMYY(new Date(promoEndDate))}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        <div className="flex justify-center">
          {/* <button className={applyPromo ? "grey-btn" : "gold-btn"} onClick={(e) => {
                        if (eligiblePromo.promotion_type === "By Total") {
                            setPromotionByTotal({ promotion: promotionByTotal.promotion, applyPromo: true })
                            setActiveTab(1)
                        } else {

                            setSaleProducts(prevData => {
                                return prevData.map(product => (product.product_id === id ? { ...product, applyPromo: true } : product))
                            });
                            if (eligiblePromo.promotion_type === "By Percent") {
                                setActiveTab(2)
                            } else if (eligiblePromo.promotion_type === "By BOGO") {
                                setActiveTab(3)
                            } else {
                                setActiveTab(4)
                            }
                        }
                        onCloseClick(e)
                    }}>{applyPromo ? "Revoke" : "Apply"}</button> */}
          <button
            className={applyPromo ? "grey-btn" : "gold-btn"}
            onClick={(e) => {
              //e.preventDefault(); // prevent form submission if inside a <form>
              // if (eligiblePromo.promotion_type === "By Total") {
              //     setPromotionByTotal({
              //         promotion: promotionByTotal.promotion,
              //         applyPromo: !applyPromo // toggle
              //     });
              //     setActiveTab(1);
              // }
              if (eligiblePromo === "By Total") {
                setPromotionByTotal({
                  promotion: promotionByTotal.promotion,
                  applyPromo: !applyPromo,
                });
                setActiveTab(1);
              } else {
                setSaleProducts((prevData) =>
                  prevData.map((product) =>
                    product.product_id === id
                      ? { ...product, applyPromo: !applyPromo }
                      : product
                  )
                );

                if (!applyPromo) {
                  // Only change tab if applying
                  if (eligiblePromo === "By Percent") {
                    setActiveTab(2);
                  } else if (eligiblePromo === "By BOGO") {
                    setActiveTab(3);
                  } else {
                    setActiveTab(4);
                  }
                }
              }

              onCloseClick(e);
            }}
          >
            {applyPromo ? "Revoke" : "Apply"}
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="table-container">
      <div className="mb-4 flex justify-between">
        <h3 className="table-title">{title}</h3>
      </div>
      <table className="x-table product-list-table retail-sales-order-table">
        <thead>
          <tr>
            <th>Barcode</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>MMK Price</th>
            <th>THB Price</th>
            <th>MMK Total</th>
            <th>THB Total</th>
            <th>Promotion</th>
            <th className="button-col"></th>
          </tr>
        </thead>
        <tbody>
          {tableRows.map((item) => {
            // console.log("MMK Total",item.convertedMMKTotal);
            const convertedPriceMMK = item.isPromoReward
              ? 0
              : convertCurrency(item, "MMK", THBToMMK, MMKToTHB);
            const convertedPriceBAHT = item.isPromoReward
              ? 0
              : convertCurrency(item, "BAHT", THBToMMK, MMKToTHB);

            let mmkTotal =
              item.mmkPrice !== null && item.mmkPrice !== undefined
                ? item.mmkPrice
                : convertedPriceMMK;
            let thbTotal =
              item.thbPrice !== null && item.thbPrice !== undefined
                ? item.thbPrice
                : convertedPriceBAHT;

            return (
              <tr
                key={item.rowKey ?? item.product_id}
                id={item.isPromoReward ? item.rowKey : item.product_id}
              >
                <td>{item.barcode}</td>
                <td>{item.product_name}</td>
                <td>
                  <input
                    id={`qty-${item.product_id}`}
                    className="retail-sales-order-input border border-solid border-neutral-300 rounded"
                    min="1"
                    defaultValue={1}
                    value={item.quantity}
                    type="text"
                    disabled={item.isPromoReward}
                    readOnly={item.isPromoReward}
                    //     pattern="^[1-9]{7,9}$"
                    // inputMode="numeric"
                    // onInput={e => {
                    //     e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    // }}

                    pattern="^[0-9]+$"
                    inputMode="numeric"
                    onInput={(e) => {
                      if (item.isPromoReward) return;
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    // onInput={(e) => {
                    //     // Remove non-numeric characters
                    //     let value = e.target.value.replace(/[^1-9]/g, "");

                    //     // Prevent value from starting with 0
                    //     if (value.startsWith("0")) {
                    //         value = value.replace(/^0+/, "");
                    //     }

                    //     // Optional: limit length to 9 digits
                    //     if (value.length > 9) {
                    //         value = value.slice(0, 9);
                    //     }

                    //     e.target.value = value;
                    // }}
                    onChange={(e) => {
                      if (item.isPromoReward) return;
                      const quantity = e.target.value;

                      if (quantity < 1) {
                        setErrorBuyMessage(
                          "Quantity must be greater than or equal 1."
                        );
                      } else if (isNaN(quantity) || quantity < 1) {
                        setErrorBuyMessage(
                          "Quantity must be digit and number."
                        );
                      } else {
                        setErrorBuyMessage("");
                      }
                      mmkTotal = (quantity * item.mmkPrice).toFixed(2);
                      thbTotal = (quantity * item.thbPrice).toFixed(2);

                      const convertedMMKTotal =
                        item.currency === "MMK"
                          ? mmkTotal
                          : (quantity * convertedPriceMMK).toFixed(2);

                      const convertedTHBTotal =
                        item.currency === "BAHT"
                          ? thbTotal
                          : (quantity * convertedPriceBAHT).toFixed(2);

                      setSaleProducts((prevData) => {
                        return prevData.map((product) =>
                          product.product_id === item.product_id
                            ? {
                                ...product,
                                quantity,
                                mmkTotal,
                                thbTotal,
                                convertedMMKTotal,
                                convertedTHBTotal,
                              }
                            : product
                        );
                      });

                      setSubTotal(getSubTotal(currencyType));
                    }}
                  />
                  {errorBuyMessage && (
                    <div className="text-red-500 text-sm mt-1">
                      {errorBuyMessage}
                    </div>
                  )}
                </td>
                <td className="retail-sales-order-amount">
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`MMK-price-${item.product_id}`}
                    className="retail-sales-order-input"
                    // const thbPrice = item.mmkPrice ? item.mmkPrice : convertCurrency(item, "MMK", exchangeRate, reverseExchangeRate)
                    //value={item.mmkPrice ? item.mmkPrice : convertCurrency(item, "MMK", THBToMMK , MMKToTHB )}
                    value={formatRetailAmount(
                      item.mmkPrice ? item.mmkPrice : convertedPriceMMK,
                      "MMK"
                    )}
                  />
                </td>
                <td className="retail-sales-order-amount">
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`THB-price-${item.product_id}`}
                    className="retail-sales-order-input"
                    value={formatRetailAmount(
                      item.thbPrice ? item.thbPrice : convertedPriceBAHT,
                      "BAHT"
                    )}
                    //value={item.thbPrice ? item.thbPrice : convertCurrency(item, "BAHT",THBToMMK, MMKToTHB )}
                  />
                </td>
                <td className="retail-sales-order-amount">
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`MMK-total-${item.product_id}`}
                    className="retail-sales-order-input"
                    //value={ (item.mmkTotal !== null && item.mmkTotal !== undefined) ? item.mmkTotal : item.convertedMMKTotal }
                    // value={item.mmkTotal ? item.mmkTotal : item.convertedMMKTotal}
                    value={formatRetailAmount(item.convertedMMKTotal, "MMK")}
                  />
                </td>

                <td className="retail-sales-order-amount">
                  <input
                    type="text"
                    readOnly={true}
                    disabled={true}
                    id={`THB-total-${item.product_id}`}
                    className="retail-sales-order-input"
                    value={formatRetailAmount(item.convertedTHBTotal, "BAHT")}
                    //value={ (item.thbTotal !== null && item.thbTotal !== undefined) ? item.thbTotal : item.convertedTHBTotal }
                    //value={item.thbTotal ? item.thbTotal : item.convertedTHBTotal}
                  />
                </td>
                <td className={item.applyPromo ? "apply" : ""}>
                  {!item.isPromoReward && item.promotion_type && (
                    <a
                      href=""
                      className={"promotion-btn"}
                      onClick={onDetailClick}
                      id={`promo-${item.product_id}`}
                    >
                      {item.promotion_type}
                    </a>
                  )}
                  {item.isPromoReward && (
                    <span className="promotion-btn">{item.promotionLabel}</span>
                  )}
                </td>
                <td
                  className="button-col"
                  onClick={(e) => {
                    if (item.isPromoReward) return;
                    const filterItem = data.filter(
                      (item) =>
                        item.product_id !== e.target.parentNode.parentNode.id
                    );
                    setSaleProducts(filterItem);
                  }}
                >
                  {!item.isPromoReward && (
                    <img
                      src={plusIcon}
                      alt="close icon"
                      className="rotate-45 w-5 h-5"
                    />
                  )}
                </td>
              </tr>
            );
          })}
          <tr id="By Total">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="font-bold">Sub Total</td>

            {currencyType == "MMK" && (
              <td className="retail-sales-order-amount">
                {formatRetailAmount(getSubTotal(currencyType, "MMK"), "MMK")}
              </td>
            )}
            {currencyType === "BAHT" && (
              <td className="retail-sales-order-amount">
                {formatRetailAmount(getSubTotal(currencyType, "BAHT"), "BAHT")}
              </td>
            )}
            {currencyType == "SEPERATED" && (
              <React.Fragment>
                <td className="retail-sales-order-amount">
                  {formatRetailAmount(getSubTotal(currencyType, "MMK"), "MMK")}
                </td>
                <td className="retail-sales-order-amount">
                  {formatRetailAmount(getSubTotal(currencyType, "BAHT"), "BAHT")}
                </td>
              </React.Fragment>
            )}

            <td className={promotionByTotal.applyPromo ? "apply" : ""}>
              {promotionByTotal.promotion && (
                <a
                  href=""
                  className="promotion-btn"
                  id="amount-promo"
                  onClick={onDetailClick}
                >
                  By Total
                </a>
              )}
            </td>
            <td className="button-col"></td>
          </tr>
        </tbody>
      </table>
      <Popup className="popup-container">
        {popup.eID === "promotion-popup" && (
          <PromotionPopup id={popup.id} promoType={popup.promoType} />
        )}
      </Popup>
    </div>
  );
};

function nearValue(input) {
  const output = Math.ceil(input / 100) * 100;
  return output;
}

export default RetailSalesOrderTable;
